import {
    LocaleEnum,
    LocaleEnumData,
    TextTokenEnum,
    LocalizerEnglishData,
    LocalizerPolishData,
    type LocaleEnumDataEntry,
    type LocalizerDataType,
    LocalizerSpanishData,
    LocalizerGermanData,
    LocalizerItalianData,
    LocalizerFrenchData,
    LocalizerPortuguese_PortugalData,
    LocalizerPortuguese_BrazilData,
} from '@/Shared/AutoGenerated/LocalizationEnum'

export default class LocalizerService {
    constructor(
        public readonly locale: LocaleEnum,
        public readonly data: LocalizerDataType,
        public readonly enumData: LocaleEnumDataEntry,
    ) {}

    static make(locale: LocaleEnum): LocalizerService {
        if (locale === LocaleEnum.English) {
            return new LocalizerService(
                LocaleEnum.English,
                LocalizerEnglishData,
                LocaleEnumData[LocaleEnum.English],
            )
        }

        if (locale === LocaleEnum.Polish) {
            return new LocalizerService(
                LocaleEnum.Polish,
                LocalizerPolishData,
                LocaleEnumData[LocaleEnum.Polish],
            )
        }

        if (locale === LocaleEnum.Spanish) {
            return new LocalizerService(
                LocaleEnum.Spanish,
                LocalizerSpanishData,
                LocaleEnumData[LocaleEnum.Spanish],
            )
        }

        if (locale === LocaleEnum.German) {
            return new LocalizerService(
                LocaleEnum.German,
                LocalizerGermanData,
                LocaleEnumData[LocaleEnum.German],
            )
        }

        if (locale === LocaleEnum.Italian) {
            return new LocalizerService(
                LocaleEnum.Italian,
                LocalizerItalianData,
                LocaleEnumData[LocaleEnum.Italian],
            )
        }

        if (locale === LocaleEnum.French) {
            return new LocalizerService(
                LocaleEnum.French,
                LocalizerFrenchData,
                LocaleEnumData[LocaleEnum.French],
            )
        }

        if (locale === LocaleEnum.Portuguese_Portugal) {
            return new LocalizerService(
                LocaleEnum.Portuguese_Portugal,
                LocalizerPortuguese_PortugalData,
                LocaleEnumData[LocaleEnum.Portuguese_Portugal],
            )
        }

        if (locale === LocaleEnum.Portuguese_Brazil) {
            return new LocalizerService(
                LocaleEnum.Portuguese_Brazil,
                LocalizerPortuguese_BrazilData,
                LocaleEnumData[LocaleEnum.Portuguese_Brazil],
            )
        }

        throw new Error(`Unknown locale '${locale}'`)
    }

    translate(textToken: TextTokenEnum): string {
        return this.data[textToken].translation
    }

    getLocale(): LocaleEnum {
        return this.locale
    }

    getShortStripeLocale(): string {
        return this.enumData.stripeShortLocale
    }
}
